module.exports = __webpack_public_path__ + "static/media/slogan-solution.b54db7d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/slogan-solution.svg
// module id = 171
// module chunks = 6